import { updateProfileAction } from '../update'
import { PROFILES_ACTION } from '../../constants'
import { PROFILE_KEY } from '../../../../../models/profile/constants'

export function updateWeeklyWorkoutsCountGoalProfileAction (value) {
  return updateProfileAction({
    type: PROFILES_ACTION.UPDATE_WEEKLY_WORKOUTS_COUNT_GOAL,
    payload: {
      key: PROFILE_KEY.WEEKLY_WORKOUTS_COUNT_GOAL,
      value
    }
  })
}
